.fp-text(v-html='text' data-test='markdown-translation')
